import MarketHoursCard from "../MarketHoursCard";

export default function MarketHoursWidget({ colSpan = 1 }: { colSpan?: number }) {
  return <MarketHoursCard colSpan={colSpan} />;
}
